export const alert = {

	elem: {
		alert: document.querySelectorAll('.alert')
	},

	init() {
		// if a cookie is not set for the alert, show it
		if (this.elem.alert.length > 0) {
			this.elem.alert.forEach( function( element ) {
				let cookieid = element.id;
				let modtime  = element.dataset.modtime;
				if (Cookies.get(cookieid) === undefined) {
					element.setAttribute('aria-hidden', 'false');
				} else if (Cookies.get(cookieid) !== undefined && Cookies.get(cookieid) !== modtime) {
					element.setAttribute('aria-hidden', 'false');				
				}

				element.querySelector('.icon-btn').addEventListener('click', alert.close);
			});
		}
	},

	// close(): close alert and set a cookie so it will not re-open 
	close(event) {
		let element = event.target.closest('.alert');
		let cookieid = element.id;		
		let modtime  = element.dataset.modtime;
		element.setAttribute('aria-hidden', 'true');
		Cookies.set(cookieid, modtime, { expires: 1 });
		// Cookies.set(cookieid, modtime, { expires: 1, Secure: true, HttpOnly: true });		
	}
};
